/* unplugin-vue-components disabled */import { render } from "./MfIcon.vue?vue&type=template&id=10509c8c&scoped=true"
import script from "./MfIcon.vue?vue&type=script&lang=js"
export * from "./MfIcon.vue?vue&type=script&lang=js"

import "./MfIcon.vue?vue&type=style&index=0&id=10509c8c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10509c8c"]])

export default __exports__